import React, { useState } from "react";
import { 
  Box,
} from '@mui/material';

import PivotTableUI from "react-pivottable/PivotTableUI";
import TableRenderers from 'react-pivottable/TableRenderers';
import "react-pivottable/pivottable.css";
import Plot from 'react-plotly.js';
import createPlotlyRenderers from 'react-pivottable/PlotlyRenderers';
const PlotlyRenderers = createPlotlyRenderers(Plot);

const PivotTable = (props) => {
  const [settings, setSettings] = useState({});
  const {data: {keys, dataset}} = props;

  return (
    <Box sx={{
      mt: 1,
      width: 900,
      height: 600,
      overflow: 'auto',
      border: '1px solid #ccc',
    }}>
      <PivotTableUI
        data={dataset}
        onChange={s => setSettings(s)}
        cols={keys}
        rows={[]}
        vals={[]}
        aggregatorName="Integer Sum"
        rendererName="Table Heatmap"
        renderers={Object.assign({}, TableRenderers, PlotlyRenderers)}
        {...settings}
        hiddenAttributes={[]}
        hiddenFromAggregators={[]}
        stringLocales="fr"
        plotlyOptions={{
          width: 630,
          height: 480
        }}
      />
    </Box>

  );
}

export default PivotTable